module.exports = __webpack_public_path__ + "img/1022.d5acf0c3.png";